import { ShivaWebPublicModule } from '@/swagger/core/public/shiva-web-public.module';
import { ShivaWebSecuredModule } from '@/swagger/core/secured/shiva-web-secured.module';
import { ShivaGNVertPublicModule } from '@/swagger/public/shiva-gn-vert-public.module';
import { ShivaGNVertSecuredModule } from '@/swagger/secured/shiva-gn-vert-secured.module';
import { importProvidersFrom } from '@angular/core';
import { environment } from 'src/environments/environment';

export const provideSwaggerCore = () => [
  importProvidersFrom(
    ShivaWebPublicModule.forRoot({
      rootUrl: environment.publicApiUrl,
    }),
    ShivaWebSecuredModule.forRoot({
      rootUrl: environment.apiUrl,
    }),
    ShivaGNVertPublicModule.forRoot({
      rootUrl: environment.publicApiUrl,
    }),
    ShivaGNVertSecuredModule.forRoot({
      rootUrl: environment.apiUrl,
    }),
  ),
];
